import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import baseUrl from "../../../api/universalApi";
import UpdateCampaign from "./UpdateCampaign";
import UpdateInvoice from "./UpdateInvoice";
import UpdateContract from "./UpdateContract";
import UpdateEscalation from "./UpdateEscalation";

const tabs = [
  { id: "campaign", label: "Edit Campaign" },
  { id: "contract", label: "Edit Contract" },
  { id: "invoice", label: "Edit Invoice" },
 
];

const EditCampaign = ({ campaignDetails, fetchAllCampaigns }) => {
  // console.log("Campaign Details:", campaignDetails);
  const [activeTab, setActiveTab] = useState("campaign");

  const renderContent = () => {
    switch (activeTab) {
      case "campaign":
        return (
          <div>
            {
              <UpdateCampaign
                campaignDetails={campaignDetails}
                fetchAllCampaigns={fetchAllCampaigns}
              />
            }
          </div>
        );
      case "contract":
        return (
          <div>
            {
              <UpdateContract
                campaignDetails={campaignDetails}
                fetchAllCampaigns={fetchAllCampaigns}
              />
            }
          </div>
        );
      case "invoice":
        return (
          <div>
            {
              <UpdateInvoice
                campaignDetails={campaignDetails}
                fetchAllCampaigns={fetchAllCampaigns}
              />
            }
          </div>
        );

    
      default:
        return null;
    }
  };

  return (
    <div className="p-4" style={{ fontFamily: "Gilroy-Medium" }}>
      <div className="flex border-b border-gray-200 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`relative px-4 py-2 text-sm font-medium focus:outline-none transition-colors duration-300 ${
              activeTab === tab.id ? "text-blue-600" : "text-gray-600"
            }`}
          >
            {tab.label}
            {activeTab === tab.id && (
              <motion.div
                layoutId="tab-underline"
                className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"
              />
            )}
          </button>
        ))}
      </div>

      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3 }}
        className="bg-white p-4 rounded shadow"
      >
        {renderContent()}
      </motion.div>
    </div>
  );
};

export default EditCampaign;
